jQuery(document).foundation();

(function () {
    'use strict';

    var BTN_PREFIX = 'js-show-gallery--';
    var GALLERY_PREFIX = 'js-gallery--';
    var GALLERY_SELECTOR = '.js-gallery';

    function cssEscape(s) {
        if (window.CSS && typeof CSS.escape === 'function') return CSS.escape(s);
        return (s + '').replace(/([^\w-])/g, '\\$1');
    }

    function nameFromButton(btn) {
        for (var i = 0; i < btn.classList.length; i++) {
            var c = btn.classList[i];
            if (c.indexOf(BTN_PREFIX) === 0) return c.slice(BTN_PREFIX.length);
        }
        return null;
    }

    function findTargetGallery(btn) {
        var selector = (btn.dataset && btn.dataset.target) || btn.getAttribute && btn.getAttribute('href');
        if (selector) {
            try {
                var el = document.querySelector(selector);
                if (el) return el;
            } catch (e) {}
        }

        var name = nameFromButton(btn);
        if (name) {
            var className = GALLERY_PREFIX + name;
            var sel = '.' + cssEscape(className);
            var gallery = document.querySelector(sel);
            if (gallery) return gallery;
        }

        var node = btn;
        for (var depth = 0; depth < 6 && node; depth++) {
            if (node.querySelector) {
                var found = node.querySelector(GALLERY_SELECTOR);
                if (found) return found;
            }
            node = node.parentElement;
        }

        var all = document.querySelectorAll(GALLERY_SELECTOR);
        if (all.length) {
            var btnRect = btn.getBoundingClientRect();
            var best = null, bestDist = Infinity;
            Array.prototype.forEach.call(all, function (g) {
                var r = g.getBoundingClientRect();
                var dy = Math.abs(r.top - btnRect.top);
                if (dy < bestDist) { bestDist = dy; best = g; }
            });
            return best;
        }

        return null;
    }

    function hideAllGalleries() {
        var all = document.querySelectorAll(GALLERY_SELECTOR);
        Array.prototype.forEach.call(all, function (g) {
            g.classList.remove('is-visible');
            g.setAttribute('aria-hidden', 'true');
        });
        // also remove active class from all buttons
        var allBtns = document.querySelectorAll('[class*="' + BTN_PREFIX + '"]');
        Array.prototype.forEach.call(allBtns, function (b) {
            b.classList.remove('is-active');
        });
    }

    function lazyLoadGallery(gallery) {
        var imgs = gallery.querySelectorAll('img[data-src], img[data-srcset], source[data-srcset]');
        Array.prototype.forEach.call(imgs, function (el) {
            var tag = el.tagName.toLowerCase();
            if (tag === 'img') {
                if (el.getAttribute('data-src') && !el.getAttribute('src')) {
                    el.setAttribute('src', el.getAttribute('data-src'));
                    el.removeAttribute('data-src');
                }
                if (el.getAttribute('data-srcset') && !el.getAttribute('srcset')) {
                    el.setAttribute('srcset', el.getAttribute('data-srcset'));
                    el.removeAttribute('data-srcset');
                }
            } else if (tag === 'source') {
                if (el.getAttribute('data-srcset') && !el.getAttribute('srcset')) {
                    el.setAttribute('srcset', el.getAttribute('data-srcset'));
                    el.removeAttribute('data-srcset');
                }
            }
        });
    }

    function imagesLoadedPromise(gallery) {
        var imgs = Array.prototype.slice.call(gallery.querySelectorAll('img'));
        var promises = imgs.map(function (img) {
            if (img.complete && img.naturalWidth && img.naturalWidth > 0) return Promise.resolve();
            return new Promise(function (resolve) {
                function done() {
                    resolve();
                }
                img.addEventListener('load', done, { once: true });
                img.addEventListener('error', done, { once: true });
            });
        });
        return promises.length ? Promise.all(promises) : Promise.resolve();
    }

    function triggerLayout(gallery) {
        // force reflow and trigger resize so Kadence/other layout scripts recalc
        // small timeout to let browser compute sizes after images load
        setTimeout(function () {
            // force reflow
            void gallery.offsetHeight;
            if (window.jQuery) try { jQuery(window).trigger('resize'); } catch (e) {}
            try { window.dispatchEvent(new Event('resize')); } catch (e) {}
            // run optional init hook again if present
            if (typeof window.initGallery === 'function') window.initGallery(gallery);
        }, 30);
    }

    document.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[class*="' + BTN_PREFIX + '"]');
        if (!btn) return;

        e.preventDefault();

        var gallery = findTargetGallery(btn);
        if (!gallery) return;

        var alreadyVisible = gallery.classList.contains('is-visible');

        // always hide others
        hideAllGalleries();

        if (!alreadyVisible) {
            // show only the matched gallery
            gallery.classList.add('is-visible');
            gallery.setAttribute('aria-hidden', 'false');
            btn.classList.add('is-active');

            // lazy-load images then trigger layout after they're ready
            lazyLoadGallery(gallery);
            imagesLoadedPromise(gallery).then(function () {
                triggerLayout(gallery);
            });

            // focus first focusable for accessibility
            var first = gallery.querySelector('a, button, [tabindex]:not([tabindex="-1"]), img');
            if (first) first.focus();

            if (typeof window.initGallery === 'function') {
                window.initGallery(gallery, btn);
            }
        } else {
            // if it was visible, we've hidden it in hideAllGalleries() so nothing else to do
            if (typeof window.teardownGallery === 'function') {
                window.teardownGallery(gallery, btn);
            }
        }
    });
})();
// Mobile: caret toggles submenu; parent text navigates (deterministic)
(function () {
  'use strict';

  // extend to desired max width
  var mq = '(max-width: 1100px)';
  var toggleSelector = '.submenu-toggle, .menu-toggle, .kt-sub-toggle, .kb-submenu-toggle, .sub-toggle';
  var HOTSPOT_PX = 120;   // px from right edge considered caret hotspot
  var HOTSPOT_PCT = 0.5;  // fallback: right half of the link is hotspot

  var lastPointer = { x: null, target: null, time: 0 };
  function recordPointer(e) {
    var x = null;
    if (e.touches && e.touches[0]) x = e.touches[0].clientX;
    else if (typeof e.clientX === 'number') x = e.clientX;
    if (x !== null) {
      lastPointer.x = x;
      lastPointer.target = e.target;
      lastPointer.time = Date.now();
    }
  }
  document.addEventListener('touchstart', recordPointer, { passive: true });
  document.addEventListener('mousedown', recordPointer, true);

  function isExplicitToggle(e) {
    return !!e.target.closest && !!e.target.closest(toggleSelector);
  }

  function getClickX(e, anchor) {
    if (Date.now() - lastPointer.time < 600 && lastPointer.x !== null) {
      if (anchor.contains(lastPointer.target) || lastPointer.target === anchor) return lastPointer.x;
    }
    if (typeof e.clientX === 'number') return e.clientX;
    if (e.touches && e.touches[0] && typeof e.touches[0].clientX === 'number') return e.touches[0].clientX;
    return null;
  }

  function toggleSubmenu(parentLi) {
    var submenu = parentLi.querySelector('[data-submenu], ul');
    if (!submenu) return;
    var toggleBtn = parentLi.querySelector(toggleSelector);
    if (toggleBtn) { toggleBtn.click(); return; }

    var isActive = submenu.classList.contains('is-active') || submenu.getAttribute('aria-hidden') === 'false';
    if (isActive) {
      submenu.classList.remove('is-active'); submenu.setAttribute('aria-hidden', 'true');
      parentLi.setAttribute('aria-expanded', 'false');
      if (window.jQuery) try { jQuery(submenu).stop(true, true).slideUp(200); } catch (e) {}
      else submenu.style.display = 'none';
    } else {
      submenu.classList.add('is-active'); submenu.setAttribute('aria-hidden', 'false');
      parentLi.setAttribute('aria-expanded', 'true');
      if (window.jQuery) try { jQuery(submenu).stop(true, true).slideDown(200); } catch (e) {}
      else submenu.style.display = 'block';
    }
  }

  // Capture-phase click handler — deterministic behavior
  document.addEventListener('click', function (e) {
    var anchor = e.target.closest && e.target.closest('.menu-item-has-children > a, .is-accordion-submenu-parent > a');
    if (!anchor) return;
    if (!window.matchMedia || !window.matchMedia(mq).matches) return;

    // ALWAYS intercept here so theme handlers can't cause accidental navigation
    e.preventDefault();
    e.stopImmediatePropagation();

    // If click landed on real toggle control, trigger it and return
    if (isExplicitToggle(e)) {
      var toggleEl = e.target.closest(toggleSelector) || anchor.parentElement.querySelector(toggleSelector);
      if (toggleEl) try { toggleEl.click(); } catch (err) {}
      return;
    }

    // If user clicked an icon/SVG inside the anchor, treat as caret click
    if (e.target.closest && e.target.closest('svg, .kb-svg-icon-wrap, .kt-submenu-toggle, .fa, .fas, .kb-submenu-toggle')) {
      toggleSubmenu(anchor.parentElement);
      return;
    }

    var href = anchor.getAttribute('href') || '';
    // placeholder links treated as toggle
    if (!href || href.trim() === '' || href === '#' || href.indexOf('javascript:') === 0) {
      toggleSubmenu(anchor.parentElement);
      return;
    }

    // compute click position and hotspot detection
    var clickX = getClickX(e, anchor);
    var clickedHotspot = false;
    if (clickX !== null) {
      var rect = anchor.getBoundingClientRect();
      var offsetInside = clickX - rect.left;
      var fromRight = rect.right - clickX;
      clickedHotspot = (fromRight >= 0 && fromRight <= HOTSPOT_PX) || (rect.width > 0 && (offsetInside / rect.width) >= HOTSPOT_PCT);
    }

    if (clickedHotspot) {
      toggleSubmenu(anchor.parentElement);
      return;
    }

    // Respect modifier keys for new-tab/new-window
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (typeof e.button === 'number' && e.button !== 0)) {
      return;
    }

    // Parent-text click -> force navigation (theme won't be able to block it now)
    try { window.location.href = href; } catch (err) {}
  }, true);
})();

